var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "bill-form" }, [_c('bill-table', { attrs: { "list": _vm.data, "timeZoneList": _vm.timeZoneList, "filterList": _vm.filterList } }), _vm._v(" "), _c('el-schema-form', { ref: "form", attrs: { "schema": _vm.schema, "model": _vm.formValue, "config": _vm.formConfig } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };